import { render, staticRenderFns } from "./show-table-block.vue?vue&type=template&id=793e3408&"
import script from "./show-table-block.vue?vue&type=script&lang=js&"
export * from "./show-table-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports